const state = {
  startCell: null,
  endCell: null,
  isDragging: false,
}

// TODO: it might be much more efficient to organise the clues by using their
// clue number as a key index 
const getters = {
  getClueByWord: state => word => {
    for (let i in state.clues) {
      let clue = state.clues[i]
      if (word === clue.solution)
        return clue
    }
    return false
  },

}

// { direction:string, clueNumber:number, clue:string }
const actions = {
  
  startDrag({ commit }, cell) {
    commit('SET_START_CELL', cell)
    commit('SET_END_CELL', cell)
    commit('SET_IS_DRAGGING', true)
  },
  
  dragOver({ commit, state }, cell) {
    if (!state.isDragging || !cell) return

    commit('SET_END_CELL', cell)
  },
  
  endDrag({ commit, state, dispatch }, cell) {
    if (!state.isDragging) return
    commit('SET_IS_DRAGGING', false)
    dispatch('wordlist/setWordFound', [state.startCell, state.endCell], {root: true})
    dispatch('grid/unhighlightAll', null, {root: true})
    commit('CLEAR_SELECTED')
  },


}

const mutations = {
  
  SET_START_CELL(state, cell) {
    state.startCell = cell
  },
  
  SET_END_CELL(state, cell) {
    state.endCell = cell
  },

  SET_IS_DRAGGING(state, isDragging) {
    state.isDragging = isDragging
  },

  CLEAR_SELECTED(state, isDragging) {
    state.startCell = null
    state.endCell = null
  },


}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}